module.exports = "/packs/media/images/dollar-tree-8a09db96f317cda23c00425781bfb35d.png";